export const MODAL_OPEN = "addResidenceAddressModal:MODAL_OPEN";
export const MODAL_CLOSE = "addResidenceAddressModal:MODAL_CLOSE";
export const MODAL_TOGGLE = "addResidenceAddressModal:MODAL_TOGGLE";
export const MODAL_UPDATE_DATA = "addResidenceAddressModal:MODAL_UPDATE_DATA";
